import { render, staticRenderFns } from "./feedback-add-or-update.vue?vue&type=template&id=84e6da50&"
import script from "./feedback-add-or-update.vue?vue&type=script&lang=js&"
export * from "./feedback-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports